var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { ActivationRequestIssueMethod } from "./types";
import gql from "graphql-tag";
import { IssueMethod, Loa, CountryCode } from "./admin-gql";
import * as isPnum from "personnummer";
import { validateNorwegianIdNumber } from "norwegian-national-id-validator";
import i18next from "i18next";
export function omitValidations(vals) {
    return vals.map(omitValidation);
}
export function omitValidation(val) {
    var validationPromise = val.validationPromise, validationError = val.validationError, rest = __rest(val, ["validationPromise", "validationError"]);
    return rest;
}
export function validateStreetAddress(streetAddress) {
    return streetAddress ? undefined : i18next.t("cc.validation.streetAddressRequired");
}
export function validatePostalCode(code) {
    return code ? undefined : i18next.t("cc.validation.postcodeMandatory");
}
export function validateAddressCity(city) {
    return city ? undefined : i18next.t("cc.validation.cityMandatory");
}
export function validateAddressSync(address) {
    return (validateStreetAddress(address.streetAddress) ||
        validatePostalCode(address.postalCode) ||
        validateAddressCity(address.city) ||
        undefined);
}
export function validatePhoneNumberAsync(phoneNumber, client) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!phoneNumber) {
                        return [2 /*return*/, null];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.query({
                            query: validatePhoneNumberGql,
                            variables: { number: phoneNumber }
                        })];
                case 2:
                    result = _a.sent();
                    if (!result.errors) {
                        if (!result.data.validatePhoneNumber) {
                            return [2 /*return*/, i18next.t("cc.validation.phoneNumberInvalid")];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                    }
                    else {
                        return [2 /*return*/, i18next.t("cc.validation.failedValidatePhoneNumber")];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    return [2 /*return*/, i18next.t("cc.validation.failedValidatePhoneNumber")];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var validatePhoneNumberGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ValidatePhoneNumber($number: String!) {\n    validatePhoneNumber(number: $number)\n  }\n"], ["\n  query ValidatePhoneNumber($number: String!) {\n    validatePhoneNumber(number: $number)\n  }\n"])));
export function validatePhoneNumberSync(phoneNumber) {
    if (!phoneNumber) {
        return i18next.t("cc.validation.telephoneNumberMissing");
    }
    if (phoneNumber.length < 5) {
        return i18next.t("cc.validation.phoneNumberInvalidDot");
    }
    return null;
}
export function createValidator(debounceTimeInMs) {
    var valCount = 0;
    var debouncedValidate = createDebouncedAsyncValidator(debounceTimeInMs);
    return function (validateSync, validateAsync, update) {
        valCount++;
        var syncResult = validateSync();
        if (syncResult) {
            update(undefined, syncResult);
            return;
        }
        var startCount = valCount;
        var validationPromise = debouncedValidate(function () { return validateAsync(); });
        update(validationPromise, undefined);
        validationPromise.then(function (result) {
            if (valCount !== startCount) {
                return;
            }
            update(undefined, result);
        });
    };
}
function createDebouncedAsyncValidator(delay) {
    var _this = this;
    var lastPromise = null;
    return function (func) {
        var resolve;
        var reject;
        lastPromise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        var thisPromise = lastPromise;
        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(thisPromise === lastPromise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, func()];
                    case 1:
                        result = _a.sent();
                        if (thisPromise === lastPromise) {
                            resolve(result);
                        }
                        else {
                            resolve(lastPromise);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        resolve(lastPromise);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        reject(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }, delay);
        return lastPromise;
    };
}
export function isValidIssueMethodForUser(issueMethod, loa, user) {
    if (loa === null) {
        return false;
    }
    if (!isValidIssueMethod(issueMethod, loa)) {
        return false;
    }
    var issueMethodInfo = issueMethods[issueMethod];
    return issueMethodInfo.userRequirement(user);
}
export function isValidIssueMethod(issueMethod, loa) {
    if (issueMethod === null || issueMethod === undefined) {
        return false;
    }
    var issueMethodInfo = issueMethods[issueMethod];
    return issueMethodInfo.loas.some(function (x) { return x === loa; });
}
var issueMethods = (_a = {},
    _a[IssueMethod.EMAIL] = {
        loas: [Loa.ONE],
        userRequirement: function (user) { return user.emails.length > 0; }
    },
    _a[IssueMethod.EMAIL_SMS] = {
        loas: [Loa.ONE, Loa.TWO],
        userRequirement: function (user) {
            return user.emails.length > 0 && user.phoneNumbers.some(function (x) { return x.canBeUsedForSmsCodes || true; });
        }
    },
    _a[IssueMethod.CODE] = {
        loas: [Loa.ONE, Loa.TWO, Loa.THREE],
        userRequirement: function (user) { return true; }
    },
    _a[ActivationRequestIssueMethod] = {
        loas: [Loa.ONE, Loa.TWO, Loa.THREE],
        userRequirement: function (user) { return true; }
    },
    _a);
export function validateEmailSync(email) {
    if (!email.value) {
        return { type: "Message", message: i18next.t("cc.validation.emailMissing") };
    }
    if (email.value.indexOf("@") === -1) {
        return { type: "Message", message: i18next.t("cc.validation.invalidEmailAddress") };
    }
    return null;
}
export function validateEmailAsync(email, organizationId, client, userId) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var result, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, client.query({
                            query: checkEmailGql,
                            variables: { email: email.value, organizationId: organizationId },
                            fetchPolicy: "network-only"
                        })];
                case 1:
                    result = _b.sent();
                    if (!result.errors) {
                        if (((_a = result.data) === null || _a === void 0 ? void 0 : _a.userByEmail) && result.data.userByEmail.id !== userId) {
                            return [2 /*return*/, { type: "AlreadyExists", userId: result.data.userByEmail.id }];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                    }
                    else {
                        return [2 /*return*/, { type: "FailedToValidate" }];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    return [2 /*return*/, { type: "FailedToValidate" }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
var checkEmailGql = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query CheckEmail($email: String!, $organizationId: String!) {\n    userByEmail(value: $email, organizationId: $organizationId) {\n      id\n    }\n  }\n"], ["\n  query CheckEmail($email: String!, $organizationId: String!) {\n    userByEmail(value: $email, organizationId: $organizationId) {\n      id\n    }\n  }\n"])));
export function checkNationalId(nationalId, organizationId, existingUserId, client) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var result, error_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!nationalId) {
                        return [2 /*return*/, null];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.query({
                            query: checkNationalIdGql,
                            variables: { nationalId: nationalId, organizationId: organizationId },
                            fetchPolicy: "network-only"
                        })];
                case 2:
                    result = _b.sent();
                    if (!result.errors) {
                        if (((_a = result.data) === null || _a === void 0 ? void 0 : _a.userByNationalId) && result.data.userByNationalId.id !== existingUserId) {
                            return [2 /*return*/, { type: "AlreadyTaken", byUserId: result.data.userByNationalId.id }];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                    }
                    else {
                        return [2 /*return*/, { type: "FailedToValidate" }];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _b.sent();
                    return [2 /*return*/, { type: "FailedToValidate" }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var checkNationalIdGql = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  query CheckNationalId($nationalId: String!, $organizationId: String!) {\n    userByNationalId(value: $nationalId, organizationId: $organizationId) {\n      id\n    }\n  }\n"], ["\n  query CheckNationalId($nationalId: String!, $organizationId: String!) {\n    userByNationalId(value: $nationalId, organizationId: $organizationId) {\n      id\n    }\n  }\n"])));
export var validPnum = function (value) { return isPnum.valid(value); };
export function validateNationalId(nationalId, country) {
    switch (country) {
        case CountryCode.SE:
            return !!validPnum(nationalId);
        case CountryCode.NO:
            return !!validateNorwegianIdNumber(nationalId);
        default:
            return false;
    }
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=validation.js.map